import { render } from "./PortfolioFooterComponent.vue?vue&type=template&id=c94d0844&scoped=true"
import script from "./PortfolioFooterComponent.vue?vue&type=script&lang=js"
export * from "./PortfolioFooterComponent.vue?vue&type=script&lang=js"

import "./PortfolioFooterComponent.vue?vue&type=style&index=0&id=c94d0844&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c94d0844"]])

export default __exports__